module.exports = "/_next/static/images/kecobo-logo-4ccb249f60b9bd4bbc493069fe02113d.png";